import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { AuthenticatedPage } from '@audacious/client';
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved, import/extensions
import PdfjsWorker from 'worker-loader!pdfjs-dist/build/pdf.worker.mjs';
import applyFluxibleContext from '@audacious/web-common/fluxible/applyFluxibleContext';
import PDFViewer from '@audacious/components/components/PDFViewer';
import NotificationsPage from './pages/notifications-page/notifications-page';
import PatientSummaryPage from './pages/patient-summary-page';
import initializeNotificationsPage from '../actions/initialize-notifications-page';

PDFViewer.setWorker(new PdfjsWorker());

class Root extends Component {
	componentDidMount() {
		const {
			fluxibleContext: { executeAction },
			history,
		} = this.props;

		executeAction(initializeNotificationsPage, {
			removeQueryParams: () => {
				history.replace({
					search: '',
				});
			},
		});
	}

	render() {
		return (
			<AuthenticatedPage id="prompt-page">
				<Switch>
					<Route exact path="/notifications">
						<NotificationsPage />
					</Route>
					<Route
						exact
						path="/notifications/:id/patient-summary"
						component={PatientSummaryPage}
					/>
					<Route>
						<Redirect to="/notifications" />
					</Route>
				</Switch>
			</AuthenticatedPage>
		);
	}
}

Root.propTypes = {
	fluxibleContext: PropTypes.shape({
		service: PropTypes.shape({
			retrieveFilterConfig: PropTypes.func.isRequired,
			retrieveFilters: PropTypes.func.isRequired,
			retrieveQuickFilters: PropTypes.func.isRequired,
			retrieveSettings: PropTypes.func.isRequired,
			getExportTask: PropTypes.func.isRequired,
		}).isRequired,
		executeAction: PropTypes.func.isRequired,
	}).isRequired,
	history: PropTypes.shape({
		replace: PropTypes.func,
	}).isRequired,
};

Root.defaultProps = {};

export default withRouter(applyFluxibleContext(Root));
